
import { mapState } from 'vuex'
import subNav from '~/components/common/subNav.vue'
import homeTab from '~/components/home/homeT.vue'
import Accounttab from '~/components/prop/Accounttab.vue'
import wikiItemList from '~/components/searchView/searchItemList.vue'
import emptyData from '~/components/common/emptyData.vue'
export default {
  components: {
    'sub-nav': subNav,
    'home-tab': homeTab,
    'wiki-item-list': wikiItemList,
    Accounttab,
    'empty-data': emptyData
  },
  provide() {
    return {
      tjdata: [],
      keywordStr: ''
    }
  },
  asyncData({ $api, app, store, route, redirect, res, $axios, $cookies, req, $serverlog, error }) {
    const comparedb = $api.home
      .invokev3data(
        {
          filterItems: []
        },
        {
          Routes: 'wikifxagg$prop_trader_ranklist,wikifxagg$prop_trader_screening,wikifxagg$prop_trader_hotsearch'
        }
      )
      .catch(() => {
        console.log('wikifxagg$prop_trader_ranklist')
      })
    return Promise.all([comparedb]).then((result) => {
      // console.log(result[0]?.wikifxagg?.prop_trader_hotsearch?.data, 222)
      const navData = [
        {
          link: '/',
          text: '20641',
          type: 'a'
        },
        {
          link: '#',
          text: '58300',
          type: 'span'
        }
      ]
      const screening = result[0]?.wikifxagg?.prop_trader_screening?.data || {}
      const propTraderScreeningSettings = screening?.settings || []
      const webSettings = [] // pc筛选条件单独做处理
      const wapSettings = [] // h5筛选条件单独做处理
      // propTraderScreeningSettings?.forEach((item) => {
      //   item.data = []
      // })
      let currencySymbol = ''
      const filterItems = []
      const filterdata = []
      const waphomesetting = []
      let freedata = [] // 费用初始值
      let freedata1 = [] // 费用初始值
      let freedata14 = [] // 盈利目标
      let freedata141 = [] // 盈利目标
      let freedata5 = [] // 每日最大回撤
      let freedata51 = [] // 每日最大回撤
      let freedata6 = [] // 最大回撤
      let freedata61 = [] // 最大回撤
      let freedata7 = [] // 最低交易日
      let freedata71 = [] // 最低交易日
      let freedata9 = [] // 最低交易日
      let freedata91 = [] // 最低交易日
      propTraderScreeningSettings?.forEach((item, index) => {
        item.listif = false
        item.listshow = false
        item?.items?.forEach((tt) => {
          tt.show = false
        })
        if (item.filterType === 1 || item.filterType === 2 || item.filterType === 3 || item.filterType === 10 || item.filterType === 11 || item.filterType === 12 || item.filterType === 13) {
          webSettings.push(item)
        } else if (webSettings.some((bool) => bool.filterType === 99)) {
          item.rangData.minData1 = item.rangData.minData
          item.rangData.maxData1 = item.rangData.maxData
          item.rangData.minData2 = item.rangData.minData
          item.rangData.maxData2 = item.rangData.maxData
          const i = webSettings.filter((item) => item.filterType === 99)[0]?.index
          webSettings[i].data.push(item)
        } else {
          item.rangData.minData1 = item.rangData.minData
          item.rangData.maxData1 = item.rangData.maxData
          item.rangData.minData2 = item.rangData.minData
          item.rangData.maxData2 = item.rangData.maxData
          webSettings.push({
            filterName: '挑战信息',
            key: '58243',
            filterType: 99,
            index,
            data: [item]
          })
        }
        if (item.filterType === 2) {
          currencySymbol = item?.items?.[0]?.currencySymbol
          item.items[0].show = true
          filterItems.push({
            codes: [item?.items[0]?.code],
            info: [
              {
                code: item?.items[0]?.code,
                name: item?.items[0]?.name
              }
            ],
            filterType: item.filterType,
            range: {}
          })
          filterdata.push({
            ...item.items?.[0],
            index1: index,
            index2: 0
          })
        }
        if (item.filterType === 4) {
          freedata = [item.rangData.minData, item.rangData.maxData]
          freedata1 = [item.rangData.minData, item.rangData.maxData]
        } else if (item.filterType === 14) {
          freedata14 = [item.rangData.minData, item.rangData.maxData]
          freedata141 = [item.rangData.minData, item.rangData.maxData]
        } else if (item.filterType === 5) {
          freedata5 = [item.rangData.minData, item.rangData.maxData]
          freedata51 = [item.rangData.minData, item.rangData.maxData]
        } else if (item.filterType === 6) {
          freedata6 = [item.rangData.minData, item.rangData.maxData]
          freedata61 = [item.rangData.minData, item.rangData.maxData]
        } else if (item.filterType === 7) {
          freedata7 = [item.rangData.minData, item.rangData.maxData]
          freedata71 = [item.rangData.minData, item.rangData.maxData]
        } else if (item.filterType === 9) {
          freedata9 = [item.rangData.minData, item.rangData.maxData]
          freedata91 = [item.rangData.minData, item.rangData.maxData]
        }
        wapSettings.push(item)
        if (item.filterType == 1 || item.filterType == 3 || item.filterType == 10) {
          item.index1 = index
          waphomesetting.push(item)
        }
      })
      return {
        freedata,
        freedata1,
        freedata14,
        freedata141,
        freedata5,
        freedata51,
        freedata6,
        freedata61,
        freedata7,
        freedata71,
        freedata9,
        freedata91,
        hotsearch: result[0]?.wikifxagg?.prop_trader_hotsearch?.data || [],
        filterdata,
        filterItems,
        navData,
        rankobj: result[0]?.wikifxagg?.prop_trader_ranklist?.data || {}, // 自营交易商排行
        screening: screening?.items || [], // 自营数据
        count: screening?.count || 0, // 自营数据总数
        propTraderScreeningSettings, // 筛选条件
        webSettings, // pc筛选条件单独做处理
        wapSettings, // h5筛选条件单独做处理
        waphomesetting,
        currencySymbol // 选择的币种
      }
    })
  },
  data() {
    return {
      tabs: [
        {
          code: 0,
          key: '58300',
          name: '自营交易商'
        },
        {
          code: 1,
          key: '58740',
          name: '账户筛选'
        }
      ],
      type: 2,
      value: [4, 8],
      active: 0,
      sliderindex1: 0,
      sliderindex2: 0,
      stepshow: '(Step1)',
      filterItems: [], // 参数
      filterdata: [], // 选中的数据
      shounum: 4,
      wapsliderindex: 0,
      wapshow: false
    }
  },
  head() {
    return {
      title: this.$t('60054'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('60052')
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      LanguageCode: 'LanguageCode',
      fatherDomain: 'fatherDomain'
    }),
    isLongLanguage() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh') return false
      else return true
    },
    ranklist() {
      // this.rankobj.propTraderCodes
      const arr = []
      this.rankobj.propTraderCodes?.forEach((item) => {
        // const arr1 = []
        // item.labels?.forEach((items) => {
        //   // items.data = [items]
        //   arr1.push(items)
        // })
        arr.push({
          project: 7,
          code: item.propTraderCode,
          annotation: item.core?.annotation,
          color: item.core?.color,
          logo: item.basic?.logo,
          localShortName: item.basic?.localShortName,
          englishShortName: item.basic?.englishShortName,
          localFullName: item.companyName,
          englishFullName: item.companyName,
          flag: item.country?.countryFlag,
          text_score: item.core?.challengeRegistrationFeeNumber,
          propTraderFeeLabel: item.core?.challengeRegistrationFeeDesc,
          website: item?.officialWebSites,
          labels: item.labels
        })
      })
      // console.log(arr, 4456)
      return arr
    }
  },
  watch: {
    // filterItems: {
    //   handler(val) {
    //     console.log(val, 998)
    //     this.filterdata = []
    //     val?.forEach((item, index) => {
    //       item.codes?.forEach((items, indexs) => {
    //         this.filterdata.push({
    //           index1: index,
    //           index2: indexs,
    //           filterType: item.filterType,
    //           code: items.code,
    //           name: item.name,
    //           items
    //         })
    //       })
    //     })
    //   },
    //   deep: true
    // }
  },
  mounted() {
    console.log(this.rankobj, 77756, this.propTraderScreeningSettings, 777, this.webSettings)
    if (this.isMobile) this.scrollfn()
  },
  methods: {
    opentab() {
      // 展开缩起
      if (this.shounum === 4) {
        this.shounum = 100
      } else {
        this.shounum = 4
      }
    },
    scrollfn() {
      // 滚动最下方滚动条
      const el1 = document.getElementById('head-overflow')
      const el2 = document.getElementById('list-overflow')
      if (!el2) return
      el2.addEventListener('scroll', function () {
        // console.log('元素正在滚动', el1.scrollLeft)
        // 在这里添加你的滚动处理代码
        el1.scrollLeft = el2.scrollLeft
      })
      el1.addEventListener('scroll', function () {
        // console.log('元素正在滚动', el1.scrollLeft)
        // 在这里添加你的滚动处理代码
        el2.scrollLeft = el1.scrollLeft
      })
    },
    tabFn(val) {
      console.log(val, 8876)
      this.active = val.code
      if (this.isMobile) this.scrollfn()
    },
    setchangefn1(val) {
      console.log(val, this.webSettings)
      this.tzxxfn(val)
    },
    setchangefn2(val) {
      // wapsliderindex
      if (!this.isMobile) {
        if (this.sliderindex1 == 0) return
        this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.minData1 = Math.ceil(val[0])
        this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.maxData1 = Math.ceil(val[1])
      } else {
        if (this.wapsliderindex == 0) return
        this.wapSettings[this.wapsliderindex].rangData.minData1 = Math.ceil(val[0])
        this.wapSettings[this.wapsliderindex].rangData.maxData1 = Math.ceil(val[2])
      }
    },
    setchangefn3(index, indexs, val) {
      console.log(index, indexs, 'index, indexs')
      if (!this.isMobile) {
        if (!this.filterItems?.some((item) => item.filterType == 2 && item.codes?.length > 0) && indexs == 0) {
          return this.$Toast({
            message: this.$t('59269'),
            position: 'middle'
          })
        }
        this.sliderindex1 = index
        this.sliderindex2 = indexs
      } else {
        console.log(val, 7776)
        if (!this.filterItems?.some((item) => item.filterType == 2 && item.codes?.length > 0) && val == 4) {
          return this.$Toast({
            message: this.$t('59269'),
            position: 'middle'
          })
        }
        this.wapsliderindex = index
      }
    },
    tzxxfn(val) {
      if (!this.isMobile) {
        if (this.filterItems.some((item) => item.filterType === this.webSettings[this.sliderindex1].data[this.sliderindex2].filterType)) {
          this.filterItems?.forEach((item, index) => {
            if (item.filterType === this.webSettings[this.sliderindex1].data[this.sliderindex2].filterType) {
              this.filterItems[index].range.minData = Math.ceil(val[0])
              this.filterItems[index].range.maxData = Math.ceil(val[1])

              this.filterItems[index].range.defaultMinData = this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.minData
              this.filterItems[index].range.defaultMaxData = this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.maxData
            }
          })
        } else {
          this.filterItems.push({
            codes: [],
            filterType: this.webSettings[this.sliderindex1].data[this.sliderindex2].filterType,
            range: {
              minData: Math.ceil(val[0]),
              maxData: Math.ceil(val[1]),
              defaultMinData: this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.minData,
              defaultMaxData: this.webSettings[this.sliderindex1].data[this.sliderindex2].rangData.maxData
            }
          })
        }
      } else if (this.isMobile) {
        if (this.filterItems.some((item) => item.filterType === this.wapSettings[this.wapsliderindex].filterType)) {
          this.filterItems?.forEach((item, index) => {
            if (item.filterType === this.wapSettings[this.wapsliderindex].filterType) {
              this.filterItems[index].range.minData = Math.ceil(val[0])
              this.filterItems[index].range.maxData = Math.ceil(val[1])

              this.filterItems[index].range.defaultMinData = this.wapSettings[this.wapsliderindex].rangData.minData
              this.filterItems[index].range.defaultMaxData = this.wapSettings[this.wapsliderindex].rangData.maxData
            }
          })
        } else {
          this.filterItems.push({
            codes: [],
            filterType: this.wapSettings[this.wapsliderindex].filterType,
            range: {
              minData: Math.ceil(val[0]),
              maxData: Math.ceil(val[1]),
              defaultMinData: this.wapSettings[this.wapsliderindex].rangData.minData,
              defaultMaxData: this.wapSettings[this.wapsliderindex].rangData.maxData
            }
          })
        }
        console.log(this.filterItems, 'this.filterItems', this.wapsliderindex, this.wapSettings)
      }
      this.screeningfn()
    },
    hzfn(val) {
      // 后缀
      if (val == 14 || val == 5 || val == 6 || val == 9) {
        return '%'
      } else if (val == 7) {
        return this.$t('22928')
      } else {
        return ''
      }
    },
    filterfn(val, index1, index2, index3) {
      // pc筛选条件
      console.log(val, 7756)
      // if (val.filterType == 3) {
      //   this.stepshow = val.extraName
      // }
      if (this.filterItems.some((item) => item.filterType === val.filterType)) {
        this.filterItems?.forEach((item, index) => {
          if (item.filterType === val.filterType && !this.filterItems[index].codes.includes(val.code) && val.filterType != 3 && val.filterType != 2) {
            this.filterItems[index].codes.push(val.code)
            this.filterItems[index].info.push({
              code: val.code,
              name: val.name
            })
            if (!this.isMobile) {
              this.webSettings[index1].items[index2].show = true
            } else {
              this.wapSettings[index1].items[index2].show = true
              if (item.filterType == 1 || item.filterType == 3 || item.filterType == 10) {
                let ii = 0
                if (item.filterType == 1) {
                  ii = 0
                } else if (item.filterType == 3) {
                  ii = 1
                }
                if (item.filterType == 10) {
                  ii = 2
                }
                this.waphomesetting[ii].items[index2].show = true
              }
            }
            this.filterdata.push({
              ...val,
              index1,
              index2
            })
          } else if (item.filterType === val.filterType && !this.filterItems[index].codes.includes(val.code) && (val.filterType === 3 || val.filterType === 2)) {
            // 单独处理步数
            console.log(1111)
            this.filterItems[index].codes = [val.code]
            this.filterItems[index].info = [
              {
                code: val.code,
                name: val.name
              }
            ]
            if (val.filterType === 3) this.stepshow = val.name === 'Instant' ? '(Instant)' : '(Step1)'
            if (!this.isMobile) {
              this.webSettings[index1].items?.forEach((a) => {
                a.show = false
              })
              this.webSettings[index1].items[index2].show = true
            } else {
              this.wapSettings[index1].items?.forEach((a) => {
                a.show = false
              })
              this.wapSettings[index1].items[index2].show = true
              if (item.filterType == 1 || item.filterType == 3 || item.filterType == 10) {
                let ii = 0
                if (item.filterType == 1) {
                  ii = 0
                } else if (item.filterType == 3) {
                  ii = 1
                }
                if (item.filterType == 10) {
                  ii = 2
                }
                this.waphomesetting[ii].items?.forEach((a) => {
                  a.show = false
                })
                this.waphomesetting[ii].items[index2].show = true
              }
            }
            if (this.filterdata?.some((tt) => tt.filterType == val.filterType)) {
              this.filterdata?.forEach((v, i) => {
                if (v.filterType === val.filterType) {
                  this.filterdata?.splice(i, 1)
                  this.filterdata.push({
                    ...val,
                    index1,
                    index2
                  })
                }
              })
            } else {
              this.filterdata.push({
                ...val,
                index1,
                index2
              })
            }
            if (val.filterType === 2) this.currencySymbol = val?.currencySymbol
          } else if (item.filterType === val.filterType && this.filterItems[index].codes.includes(val.code)) {
            const i = this.filterItems[index].codes.indexOf(val.code)
            this.filterItems[index].codes.splice(i, 1)
            this.filterItems[index].info.splice(i, 1)
            if (!this.isMobile) {
              this.webSettings[index1].items[index2].show = false
            } else {
              this.wapSettings[index1].items[index2].show = false
              if (item.filterType == 1 || item.filterType == 3 || item.filterType == 10) {
                let ii = 0
                if (item.filterType == 1) {
                  ii = 0
                } else if (item.filterType == 3) {
                  ii = 1
                }
                if (item.filterType == 10) {
                  ii = 2
                }
                this.waphomesetting[ii].items[index2].show = false
              }
            }

            if (this.filterItems[index].codes?.length == 0 && val.filterType != 3) {
              this.filterItems.splice(index, 1)
            } else if (this.filterItems[index].codes?.length == 0 && val.filterType == 3) {
              this.filterItems.splice(index, 1)
              this.stepshow = val.name == 'Instant' ? '(Instant)' : '(Step1)'
            }
            // const num = this.filterdata.indexOf(val.code)
            // this.filterdata.push(val)
            this.filterdata?.forEach((a, b) => {
              if (a.code == val.code) {
                this.filterdata.splice(b, 1)
              }
            })
            if (val.filterType == 2) {
              this.freedata = JSON.parse(JSON.stringify(this.freedata1))
              console.log(this.freedata, 99976)
              this.currencySymbol = ''
            }
            console.log(222, this.webSettings, i, index1, index2)
          }
        })
      } else {
        this.filterItems.push({
          codes: [val.code],
          info: [
            {
              code: val.code,
              name: val.name
            }
          ],
          filterType: val.filterType,
          range: {}
        })
        this.filterdata.push({
          ...val,
          index1,
          index2
        })
        if (val.filterType == 3) this.stepshow = val.name === 'Instant' ? '(Instant)' : '(Step1)'
        if (val.filterType == 2) this.currencySymbol = val?.currencySymbol
        if (!this.isMobile) {
          this.webSettings[index1].items[index2].show = true
        } else {
          this.wapSettings[index1].items[index2].show = true
          if (val.filterType == 1 || val.filterType == 3 || val.filterType == 10) {
            let ii = 0
            if (val.filterType == 1) {
              ii = 0
            } else if (val.filterType == 3) {
              ii = 1
            }
            if (val.filterType == 10) {
              ii = 2
            }
            this.waphomesetting[ii].items[index2].show = true
          }
        }
      }

      // 单独处理币种选中和去除
      const t1 = JSON.parse(JSON.stringify(this.filterItems))
      console.log(2222, t1)
      if (t1.filter((item) => item.filterType == 2)?.length == 0) {
        const filterarr = []
        t1?.forEach((a, b) => {
          if (a.filterType != 4) {
            filterarr.push(a)
          }
        })
        this.filterItems = filterarr
      }
      this.screeningfn()

      if (this.isMobile) {
        // wap-overflow-auto
        const ele1 = document.getElementsByClassName('wap-overflow-auto')
        const ele2 = ele1[index3]?.querySelectorAll('.wap-overflow-auto-span')
        console.log(index3, ele1[index3])
        if (!ele2) return
        const left1 = ele2[0].getBoundingClientRect().left
        for (let i = 0; i < ele2?.length; i++) {
          const w = ele2[i].clientWidth + ele2[i].getBoundingClientRect().left - ele1[index3].clientWidth - left1
          const l = ele1[index3].scrollLeft - (ele2[i].getBoundingClientRect().left - left1)
          // console.log(ele2[i].clientWidth, ele2[i].getBoundingClientRect().left, 887, ele1[index1].clientWidth, w)
          // ele2[i].getBoundingClientRect().left + ele2[i].clientWidth
          // const bool = ele2[i].getBoundingClientRect().left > ele1[index1].scrollLeft && ele2[i].getBoundingClientRect().left + ele2[i].clientWidth < ele1[index1].scrollLeft + ele1[index1].clientWidth - ele2[i].clientWidth
          // console.log(ele2[i].getBoundingClientRect().left, 8887, ele1[index1].scrollLeft, bool, 777, ele2[i].getBoundingClientRect().left + ele2[i].clientWidth, ele1[index1].scrollLeft + ele1[index1].clientWidth - ele2[i].clientWidth)
          if (w > 0 && i == index2) {
            ele1[index3].scrollLeft = w + 5
          } else if (l > 0 && i == index2) {
            ele1[index3].scrollLeft = ele2[i].getBoundingClientRect().left - left1 - 5
          }
        }
      }
      // console.log(JSON.parse(JSON.stringify(this.filterItems)), 'this.filterItems', this.wapSettings)
    },
    screeningfn() {
      this.$api.common
        .CV3(
          {
            filterItems: JSON.parse(JSON.stringify(this.filterItems))
          },
          { Routes: 'wikifxagg$prop_trader_screening' }
        )
        .then((result) => {
          const obj = result?.wikifxagg?.prop_trader_screening?.data || {}
          this.count = obj?.count || 0
          this.screening = obj?.items || []
          this.$nextTick(() => {
            if (this.isMobile) this.scrollfn()
          })
        })
        .catch(() => {
          console.log('wikifxagg$prop_trader_screening------error')
        })
    },
    remlvefilterdatafn(item) {
      // 删除条件
      this.filterfn(item, item.index1, item.index2)
      console.log(this.webSettings, 111, item)
      // this.webSettings[item.index1].items[item.index2].show = false
      this.$nextTick(() => {
        // this.filterdata?.splice(item.index2, 1)
      })
    },
    removeallfn() {
      this.filterdata = []
      this.filterItems = []
      this.freedata = this.freedata1
      this.freedata14 = this.freedata141
      this.freedata5 = this.freedata51
      this.freedata6 = this.freedata61
      this.freedata7 = this.freedata71
      this.freedata9 = this.freedata91
      this.stepshow = '(Step1)'
      console.log(this.webSettings, 9998)
      this.webSettings?.forEach((item) => {
        item?.items?.forEach((items) => {
          items.show = false
        })
      })
      this.wapSettings?.forEach((item) => {
        item?.items?.forEach((items) => {
          items.show = false
        })
      })
      this.waphomesetting?.forEach((item) => {
        item?.items?.forEach((items) => {
          items.show = false
        })
      })
      this.screeningfn()
    },
    close() {
      this.wapshow = false
      this.$nextTick(() => {
        if (this.isMobile) this.scrollfn()
      })
    },
    opentabfn() {
      this.wapshow = true
      this.$nextTick(() => {
        // 计算每个字类高度 settinglist-son
        const settinglist = document.getElementsByClassName('settinglist')
        for (let i = 0; i < settinglist?.length; i++) {
          const h = settinglist[i]?.querySelectorAll('.settinglist-son')?.[0]?.clientHeight
          if (h > 110) {
            this.wapSettings[i].listif = true
          }
        }
      })
    },
    taggerfn(index) {
      this.wapSettings[index].listshow = !this.wapSettings[index].listshow
    }
  }
}
